var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDeviceDLayer(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ic-device-d-layer-a",
    x1: "44.58%",
    x2: "70.129%",
    y1: "44.565%",
    y2: "78.568%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A8B9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ic-device-d-layer-b",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "99.634%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BBC5D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#DFE5F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ic-device-d-layer-c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BBC5D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#DFE5F0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E7EEFB",
    d: "M33,4 C34.6568542,4 36,5.34314575 36,7 L36,12 L15,12 C13.4023191,12 12.0963391,13.24892 12.0050927,14.8237272 L12,15 L12,36 L7,36 C5.34314575,36 4,34.6568542 4,33 L4,7 C4,5.34314575 5.34314575,4 7,4 L33,4 Z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12 12)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    x: 1,
    y: 1,
    stroke: "url(#ic-device-d-layer-a)",
    strokeWidth: 2,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#ic-device-d-layer-b)",
    strokeWidth: 2,
    d: "M26,7 L26,25 L6,25 L6,7 L26,7 Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.5,
    height: 20,
    x: 12,
    y: 6,
    fill: "url(#ic-device-d-layer-c)",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.5,
    height: 20,
    x: 18.5,
    y: 6,
    fill: "url(#ic-device-d-layer-c)",
    rx: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDeviceDLayer);
export default __webpack_public_path__ + "static/media/ic-device-d-layer.41a6cd68181ac81cc2f73890d53eb602.svg";
export { ForwardRef as ReactComponent };